import React, { ReactElement } from 'react';
import styled from 'styled-components';
import CheckboxBase from '../CheckboxStyle';

const Wrapper = styled.div<{ align?: 'left' | 'center' | 'right' }>`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  width: fit-content;
  padding: 4px 0;
  margin: ${({ align }) => {
    if (align === 'center') return '0 auto';
    if (align === 'right') return '0 0 0 auto';
    return '0';
  }};

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const Label = styled.label`
  margin-left: 6px;
  transition: all 0.2s;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  line-height: 1.2;

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
  }
`;

interface CheckboxProps {
  value: string;
  onChange?: any;
  checked: boolean;
  name?: string;
  id?: string;
  children?: ReactElement | string | undefined;
  defaultChecked?: boolean;
  disabled?: boolean;
  align?: 'left' | 'center' | 'right'; // 🆕 정렬 옵션
}

function Checkbox({
  checked,
  name,
  disabled,
  value,
  id = value,
  onChange,
  defaultChecked,
  children,
  align = 'left',
}: CheckboxProps) {
  return (
    <Wrapper align={align}>
      <CheckboxBase
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={checked}
        disabled={disabled}
        type="checkbox"
      />
      {children && <Label htmlFor={id}>{children}</Label>}
    </Wrapper>
  );
}

export default React.memo(Checkbox);
